import { render } from "./mass-locks-grid.vue?vue&type=template&id=9fcc7ef4"
import script from "./mass-locks-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./mass-locks-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/locks/mass-locks-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9fcc7ef4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9fcc7ef4', __exports__)) {
    api.reload('9fcc7ef4', __exports__)
  }
  
  module.hot.accept("./mass-locks-grid.vue?vue&type=template&id=9fcc7ef4", () => {
    api.rerender('9fcc7ef4', render)
  })

}


export default __exports__